import ApiService from './ApiService'

import HARDCODE from '../business-const/HardCode/HardCode'



class VwClienteAcessoApoliceService extends ApiService {

    constructor() {
        super(HARDCODE.apiVwClienteAcessoApolice)
    }

    async buscarApoliceList(variaveisGlobais, filtroList) {

        /*
        const { params, paramsAux } = await this.calculaParamsFiltroList(variaveisGlobais, null, filtroList, true)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoApoliceBuscarApoliceList}/?${params}`,
            paramsAux, false)
        */
            
        const body = await this.calculaBodyFiltroList(variaveisGlobais, null, filtroList, true)

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoApoliceBuscarApoliceList, body, false)
    }
    
    async sumApolice(variaveisGlobais, campoAgrupamento, filtroList) {

        /*
        const { params, paramsAux } = await this.calculaParamsFiltroList(variaveisGlobais, campoAgrupamento, filtroList, true)

        return this.getParams(variaveisGlobais, `${HARDCODE.apiVwClienteAcessoApoliceSumApolice}/?${params}`, paramsAux, false)
        */

        const body = await this.calculaBodyFiltroList(variaveisGlobais, campoAgrupamento, filtroList, true)

        return this.put(variaveisGlobais, HARDCODE.apiVwClienteAcessoApoliceSumApolice, body, false)
    }
}

export default VwClienteAcessoApoliceService